export default function isTruthy(value) {
  return !!value;
}
